export default __webpack_public_path__ + "95dec52352601492cec5241acdbe4765.png";